import React, { useRef, useEffect, useCallback } from 'react';

/**
 * setInterval Custom Hook
 * @param callback 동작시킬 함수
 * @param delay 초 단위
 */
function useInterval(
  callback: () => void,
  param: { delay: number; isInvoke: boolean; isFirstInvoke?: boolean },
  dependencies: any[],
) {
  const savedCallback = useCallback(callback, [...dependencies]);

  /**
   * * interval 세팅
   */
  useEffect(() => {
    const { delay, isInvoke, isFirstInvoke } = param;
    if (isInvoke) {
      isFirstInvoke && savedCallback();
      const id = setInterval(savedCallback, delay * 1000);
      return () => clearInterval(id);
    }
  }, [savedCallback, param.delay, param.isInvoke, param.isFirstInvoke]);
}

export default useInterval;
